import type { PageMeta } from "./en";

export const enLongTail: Record<string, PageMeta> = {
  "weekly-rashifal": {
    title: "Weekly Rashifal — Saptahik Horoscope for 12 Rashi | Ishvaram",
    description:
      "Saptahik Rashifal: the week ahead for all 12 rashis \u2014 career, health and love.",
  },
  yoga: {
    title: "Yogas in Vedic Astrology \u2014 Auspicious Planetary Combinations | Ishvaram",
    description:
      "Learn about Yogas in Vedic astrology\u2014auspicious planetary combinations. Understand Raja Yoga, Dhana Yoga, and other beneficial yogas in your birth chart.",
  },
  "mahadasha/ketu": {
    title: "Ketu Mahadasha: 7-Year Shadow Period & Remedies | Ishvaram.com",
    description:
      "Ketu Mahadasha (7 years): why it unsettles career and relationships, and Vedic remedies from Brihat Parashara Hora Shastra.",
    ogTitle: "Ketu Mahadasha: 7-Year Shadow Period & Remedies | Ishvaram.com",
    ogDescription:
      "Why does Ketu's 7-year Mahadasha disrupt careers/relationships? Learn Vedic remedies from Brihat Parashara Hora Shastra to harness its transformative power.",
  },
  "mahadasha/rahu": {
    title: "Rahu Mahadasha (18 Years): Karmic Debt, Power & Transformation",
    description:
      "Why does Rahu's 18-year Mahadasha bring sudden gains & turmoil? Vedic remedies to harness shadow planets' energy & balance karma.",
    ogTitle: "Rahu Mahadasha (18 Years): Karmic Debt, Power & Transformation",
    ogDescription:
      "Why does Rahu's 18-year Mahadasha bring sudden gains & turmoil? Vedic remedies to harness shadow planets' energy & balance karma.",
  },
  "mahadasha/sun": {
    title: "Surya Mahadasha (6 Years): Power, Authority & Life Purpose",
    description:
      "Discover how Surya Mahadasha (6 years) shapes leadership, vitality, and life purpose.",
    ogTitle: "Surya Mahadasha (6 Years): Power, Authority & Life Purpose",
    ogDescription:
      "Discover how Surya Mahadasha (6 years) shapes leadership, vitality, and life purpose. Learn Vedic remedies to harness Sun's power for career success and health.",
  },
  "today-horoscope": {
    title: "Daily Vedic Jyotish Predictions – Free Kundali Analysis & Remedies",
    description:
      "Get free daily horoscope predictions for all 12 zodiac signs (Rashis) with Vedic astrology insights.",
    ogTitle: "Daily Vedic Jyotish Predictions – Free Kundali Analysis & Remedies",
    ogDescription:
      "Get free daily horoscope predictions for all 12 zodiac signs (Rashis) with Vedic astrology insights. Learn remedies (upay) from expert analysis based on planetary positions.",
  },
  "tomorrow-horoscope": {
    title: "Tomorrow's Horoscope: Vedic Jyotish Predictions for All Rashis",
    description:
      "Get daily Vedic astrology predictions for all 12 rashis. Real planetary positions, free Hindi & English horoscopes.",
    ogTitle: "Tomorrow's Horoscope: Vedic Jyotish Predictions for All Rashis",
    ogDescription:
      "Get daily Vedic astrology predictions for all 12 rashis. Real planetary positions, free Hindi & English horoscopes.",
  },

  // No year tokens on ketu/rahu/saturn/venus: these guides are year-agnostic
  // (their H1s carry no year) and the token resolves from a module-load clock,
  // so the title claimed a year the page never substantiates (2026-09-08).
  // jupiter-transit, transits and shani-transit keep {year}: engine-backed.
  "ketu-transit": {
    title: "Ketu Transit: Hidden Karmic Lessons Unfolding",
    description:
      "Understand Ketu transit effects on your kundali. Learn Vedic remedies (upay) to balance karmic energy and life challenges during this period.",
    ogTitle: "Ketu Transit: Hidden Karmic Lessons Unfolding",
    ogDescription:
      "Understand Ketu transit effects on your kundali. Learn Vedic remedies (upay) to balance karmic energy and life challenges during this period.",
  },
  "mahadasha/mars": {
    title: "Mangal Mahadasha: 7-Year Fire Element & Kundali Impact",
    description:
      "Mangal Mahadasha (7 years): why it brings sudden challenges and property matters, with Vedic upay from Brihat Parashara Hora Shastra.",
    ogTitle: "Mangal Mahadasha: 7-Year Fire Element & Kundali Impact",
    ogDescription:
      "Why does Mangal Mahadasha bring sudden challenges? Learn Vedic remedies (upay) per Brihat Parashara Hora Shastra to balance Mars' fiery energy & achieve success.",
  },
  "manglik-calculator": {
    title: "Mangal Dosha Checker – Instant Kundali Analysis by Date of Birth",
    description:
      "Check Mangal Dosha (Mars affliction) in your kundali using our free Manglik calculator. Know compatibility & remedies from Vedic Jyotish experts.",
    ogTitle: "Mangal Dosha Checker – Instant Kundali Analysis by Date of Birth",
    ogDescription:
      "Check Mangal Dosha (Mars affliction) in your kundali using our free Manglik calculator. Know compatibility & remedies from Vedic Jyotish experts.",
  },
  "mercury-retrograde": {
    title: "Mercury Retrograde (Budh Vakri): Navigate Communication Challenges with Vedic Wisdom",
    description:
      "Struggling with miscommunication, delays? Learn Vedic astrology's insights on Mercury retrograde (Budh Vakri) and practical upay to mitigate its effects.",
    ogTitle: "Mercury Retrograde (Budh Vakri): Navigate Communication Challenges with Vedic Wisdom",
    ogDescription:
      "Struggling with miscommunication, delays? Learn Vedic astrology's insights on Mercury retrograde (Budh Vakri) and practical upay to mitigate its effects.",
  },
  "nadi-astrology": {
    title: "Nadi Astrology: Unlocking Life's Hidden Palm-Leaf Secrets",
    description:
      "Discover how South Indian Nadi astrology predicts life's path through ancient palm-leaf manuscripts.",
    ogTitle: "Nadi Astrology: Unlocking Life's Hidden Palm-Leaf Secrets",
    ogDescription:
      "Discover how South Indian Nadi astrology predicts life's path through ancient palm-leaf manuscripts. Learn about its accuracy, key principles, and remedies.",
  },
  "rahu-transit": {
    title: "Rahu Transit: Effects on Lagna & Rashi + Remedies",
    description:
      "Rahu transit effects on lagna & rashi. Vedic remedies (upay) from Brihat Parashara Hora Shastra to neutralize negative impacts.",
    ogTitle: "Rahu Transit: Effects on Lagna & Rashi + Remedies",
    ogDescription:
      "Rahu transit effects on lagna & rashi. Vedic remedies (upay) from Brihat Parashara Hora Shastra to neutralize negative impacts.",
  },
  "saturn-transit": {
    title: "Shani Gochar: How Saturn's Transit Affects Your Kundali",
    description:
      "Understand Shani Gochar: How Saturn's transit impacts career, health, relationships. Vedic remedies & planetary positions explained by expert Jyotish.",
    ogTitle: "Shani Gochar: How Saturn's Transit Affects Your Kundali",
    ogDescription:
      "Understand Shani Gochar: How Saturn's transit impacts career, health, relationships. Vedic remedies & planetary positions explained by expert Jyotish.",
  },
  "venus-transit": {
    title: "Shukra Gochar: Venus Transit Impact on Wealth & Relationships",
    description:
      "Understand Shukra Gochar: Venus transit effects, remedies, and timing for wealth, love, health. Align your actions with Vedic astrology insights.",
    ogTitle: "Shukra Gochar: Venus Transit Impact on Wealth & Relationships",
    ogDescription:
      "Understand Shukra Gochar: Venus transit effects, remedies, and timing for wealth, love, health. Align your actions with Vedic astrology insights.",
  },

  "jupiter-transit": {
    title: "Guru Gochar {year}: Jupiter's Dharma Boost & Remedies",
    description:
      "Jupiter's {year} transit (Guru Gochar) – how it shapes dharma, wealth and wisdom across all rashis. Get Vedic upay for prosperity.",
    ogTitle: "Guru Gochar {year}: Jupiter's Dharma Boost & Remedies",
    ogDescription:
      "Jupiter's {year} transit (Guru Gochar) – how it shapes dharma, wealth and wisdom across all rashis. Get Vedic upay for prosperity.",
  },
  mahadasha: {
    title: "Vimshottari Mahadasha: Your 120-Year Kundali Cycle Explained",
    description:
      "Discover how the 120-year Vimshottari Mahadasha system governs life phases through 9 planets. Learn dasha periods, planetary influences, and remedies.",
    ogTitle: "Vimshottari Mahadasha: Your 120-Year Kundali Cycle Explained",
    ogDescription:
      "Discover how the 120-year Vimshottari Mahadasha system governs life phases through 9 planets. Learn dasha periods, planetary influences, and remedies.",
  },
  "mahadasha/jupiter": {
    title: "Guru (Jupiter) Mahadasha: 16-Year Wisdom & Prosperity Guide",
    description:
      "Explore the transformative power of Guru (Jupiter) Mahadasha (16 years). Learn Vedic insights, remedies for wisdom & prosperity.",
    ogTitle: "Guru (Jupiter) Mahadasha: 16-Year Wisdom & Prosperity Guide",
    ogDescription:
      "Explore the transformative power of Guru (Jupiter) Mahadasha (16 years). Learn Vedic insights, remedies for wisdom & prosperity.",
  },
  "mahadasha/mercury": {
    title: "Budh Mahadasha: 17-Year Mercury Dasha Significance & Remedies",
    description:
      "Understand Budh (Mercury) Mahadasha's 17-year impact on communication, intellect, and daily life.",
    ogTitle: "Budh Mahadasha: 17-Year Mercury Dasha Significance & Remedies",
    ogDescription:
      "Understand Budh (Mercury) Mahadasha's 17-year impact on communication, intellect, and daily life. Learn Vedic remedies from Brihat Parashara Hora Shastra to harness its energy wisely.",
  },

  // ── Sade Sati sub-pages ───────────────────────────────────────────────────
  "sade-sati/symptoms": {
    title: "Sade Sati Symptoms — 8 Signs You Are in Shani's 7.5-Year Period | Ishvaram",
    description:
      "Sade Sati symptoms: unusual delays, financial pressure, health issues, sleep problems, and more.",
    ogTitle: "Sade Sati Symptoms — 8 Signs You Are Under Shani | Ishvaram",
    ogDescription:
      "Is Saturn making your life harder? These 8 classical Jyotish symptoms tell you if you are in Sade Sati — and what to do about it.",
  },
  "sade-sati/upay": {
    title: "Sade Sati Upay — Shani Remedies That Actually Work | Ishvaram",
    description:
      "Sade Sati upay from classical Jyotish: Shani mantras, Hanuman Chalisa, Saturday fasts, til donations, and temple visits.",
    ogTitle: "Sade Sati Upay — Shani Remedies From Classical Jyotish | Ishvaram",
    ogDescription:
      "Classical upay for Sade Sati: mantras, fasts, charity, and temple rituals that align with Saturn's principles of karma and discipline.",
  },
  "sade-sati/puja-cost": {
    title: "Sade Sati Puja Cost — Shani Shanti Puja Rates & What to Expect | Ishvaram",
    description:
      "Sade Sati puja cost in India: at-home pandit rates ₹1,100–₹5,100, Shani Shingnapur visit ₹2,100–₹11,000, Siddhatek and other temple rates.",
    ogTitle: "Sade Sati Puja Cost — Rates for Shani Shanti Puja in India | Ishvaram",
    ogDescription:
      "Realistic Sade Sati puja costs: ₹1,100 self-service to ₹21,000 at Shani Shingnapur. Know what you're paying for before booking.",
  },
  "sade-sati/phases": {
    title: "3 Phases of Sade Sati — Rising, Peak & Setting Explained | Ishvaram",
    description:
      "Sade Sati's three 2.5-year phases: rising (12th from Moon) brings restlessness, peak (1st) the most pressure, setting (2nd) family and money strain.",
    ogTitle: "3 Phases of Sade Sati — What Each 2.5-Year Phase Means | Ishvaram",
    ogDescription:
      "Rising, peak, and setting — the three Sade Sati phases each carry different challenges and upay. Know which phase you are in and what to expect.",
  },

  // ── Pitra Dosha sub-pages ─────────────────────────────────────────────────
  "pitra-dosha/symptoms": {
    title: "Pitra Dosha Symptoms — Signs of Ancestral Karma Blocking You | Ishvaram",
    description:
      "Pitra Dosha symptoms: repeated failures despite hard work, delays in progeny, father's poor health, inexplicable obstacles.",
    ogTitle: "Pitra Dosha Symptoms — 8 Signs Ancestral Karma Is Blocking You | Ishvaram",
    ogDescription:
      "Is Pitra Dosha the invisible wall holding you back? These 8 classical signs in life and chart reveal ancestral karma that needs resolution.",
  },
  "pitra-dosha/upay": {
    title: "Pitra Dosha Upay — Ancestral Remedies From Classical Jyotish | Ishvaram",
    description:
      "Pitra Dosha upay: Pitru Tarpan, Shraddh on Amavasya, Gaya Shraddh, feeding Brahmins and crows, Sun mantras.",
    ogTitle: "Pitra Dosha Upay — How to Resolve Ancestral Karmic Debt | Ishvaram",
    ogDescription:
      "Classical Pitra Dosha remedies: Pitru Tarpan, Shraddh rituals, Gaya pilgrimage, and daily Sun mantras that restore ancestral blessings.",
  },
  "pitra-dosha/puja-cost": {
    title: "Pitra Dosha Puja Cost — Tarpan, Shraddh & Narayan Bali Rates | Ishvaram",
    description:
      "Pitra Dosha puja cost: daily tarpan at home ₹100–₹500, Gaya Shraddh ₹5,000–₹25,000, Narayan Bali/Nagbali at Trimbakeshwar ₹11,000–₹1,50,000.",
    ogTitle: "Pitra Dosha Puja Cost — Tarpan to Narayan Bali Rates | Ishvaram",
    ogDescription:
      "Honest Pitra Dosha puja costs: ₹1,001 home tarpan to ₹51,000+ Narayan Bali. Know the difference and choose the right remedy for your chart.",
  },

  // ── Kaal Sarp Dosha sub-pages ─────────────────────────────────────────────
  "kaal-sarp-dosha/symptoms": {
    title: "Kaal Sarp Dosh Symptoms — 8 Signs All Planets Are Hemmed in Your Chart | Ishvaram",
    description:
      "Kaal Sarp Dosh symptoms: simultaneous struggles in career, relationships, and health; snake dreams; repeated setbacks despite effort.",
    ogTitle: "Kaal Sarp Dosh Symptoms — 8 Signs You Have This Configuration | Ishvaram",
    ogDescription:
      "Simultaneous career, marriage, and health struggles? Snake dreams? These 8 classical signs indicate Kaal Sarp Dosh in your birth chart.",
  },
  "kaal-sarp-dosha/upay": {
    title: "Kaal Sarp Dosh Upay — Proven Vedic Remedies That Work | Ishvaram",
    description:
      "Kaal Sarp Dosh upay: Trimbakeshwar or Mahakaleshwar puja, Rudrabhishek, Maha Mrityunjaya mantra, Rudraksha mala, Nag Puja on Nag Panchami.",
    ogTitle: "Kaal Sarp Dosh Upay — Trimbakeshwar Puja & Classical Remedies | Ishvaram",
    ogDescription:
      "Classical upay for Kaal Sarp Dosh: Trimbakeshwar puja, Rudrabhishek, Maha Mrityunjaya mantra, and Nag Puja rituals that work.",
  },
  "kaal-sarp-dosha/puja-cost": {
    title: "Kaal Sarp Dosh Puja Cost — Trimbakeshwar & Other Rates | Ishvaram",
    description:
      "Kaal Sarp Dosh puja cost: Trimbakeshwar ₹5,100–₹25,000, at-home pandit ₹2,100–₹11,000, full Narayan Nagbali ₹25,000–₹1,50,000.",
    ogTitle: "Kaal Sarp Dosh Puja Cost — Trimbakeshwar to At-Home Rates | Ishvaram",
    ogDescription:
      "Honest Kaal Sarp Dosh puja costs: ₹2,100 simple upay to ₹1.5 lakh full Narayan Nagbali. Which one does your chart actually need?",
  },
  "kaal-sarp-dosha/types": {
    title: "12 Types of Kaal Sarp Dosh — Anant to Sheshnag Explained | Ishvaram",
    description:
      "All 12 types of Kaal Sarp Dosh: Anant, Kulik, Vasuki, Shankhpal, Padma, Mahapadma, Takshak, Karkotak, Shankhchoor, Ghatak, Vishdhar, Sheshnag.",
    ogTitle: "12 Types of Kaal Sarp Dosh — All Types with Effects & Remedies | Ishvaram",
    ogDescription:
      "Which Kaal Sarp Dosh type is in your chart? All 12 types from Anant to Sheshnag — their Rahu-Ketu positions, effects on life, and specific remedies.",
  },

  // ── Mangal Dosha sub-pages ────────────────────────────────────────────────
  "mangal-dosha-calculator/symptoms": {
    title: "Mangal Dosha Symptoms — Signs of Manglik in Your Birth Chart | Ishvaram",
    description:
      "Mangal Dosha symptoms: repeated relationship failures, controlling nature, aggressive speech, partner's health issues.",
    ogTitle: "Mangal Dosha Symptoms — 8 Signs You Are Manglik | Ishvaram",
    ogDescription:
      "Repeated relationship struggles, aggressive energy, partner's health issues? These 8 classical signs indicate Mangal Dosha in your birth chart.",
  },
  "mangal-dosha-calculator/upay": {
    title: "Mangal Dosha Upay — Manglik Remedies From Classical Jyotish | Ishvaram",
    description:
      "Mangal Dosha upay: Kumbh Vivah, Mangalnath Ujjain puja, Hanuman puja on Tuesdays, coral gemstone, Mangal mantra chanting, fasting.",
    ogTitle: "Mangal Dosha Upay — Classical Remedies for Manglik | Ishvaram",
    ogDescription:
      "Classical upay for Mangal Dosha: Kumbh Vivah, Hanuman puja, Mangal mantras, and gemstone remedies that reduce Manglik effects in marriage.",
  },
  "mangal-dosha-calculator/puja-cost": {
    title: "Mangal Dosha Puja Cost — Mangal Shanti Rates in India | Ishvaram",
    description:
      "Mangal Dosha puja cost: at-home Mangal Shanti ₹2,100–₹11,000, Mangalnath Ujjain ₹5,100–₹25,000, Kumbh Vivah ritual ₹3,100–₹11,000.",
    ogTitle: "Mangal Dosha Puja Cost — Mangal Shanti to Kumbh Vivah Rates | Ishvaram",
    ogDescription:
      "Honest Mangal Dosha puja costs: ₹2,100 home puja to ₹25,000 at Mangalnath Ujjain. Know what to spend before booking a pandit.",
  },
  "mangal-dosha-calculator/marriage": {
    title: "Mangal Dosha and Marriage — Complete Manglik Compatibility Guide | Ishvaram",
    description:
      "Mangal Dosha in marriage: when it matters, the conditions that cancel it, Manglik-to-Manglik matching, and what your chart says about the relationship.",
    ogTitle: "Mangal Dosha and Marriage — Manglik Compatibility Guide | Ishvaram",
    ogDescription:
      "Manglik in marriage: real effects, cancellation conditions, and whether Manglik-Manglik matching is actually safer. A complete classical guide.",
  },

  "mahadasha/moon": {
    title: "Chandra Mahadasha: 10-Year Lunar Influence & Remedies",
    description:
      "Discover Chandra's 10-year Mahadasha period, its impact on mind/emotions, and Vedic remedies (upay) from Brihat Parashara Hora Shastra.",
    ogTitle: "Chandra Mahadasha: 10-Year Lunar Influence & Remedies",
    ogDescription:
      "Discover Chandra's 10-year Mahadasha period, its impact on mind/emotions, and Vedic remedies (upay) from Brihat Parashara Hora Shastra. Strengthen your lagna during Chandra's gochar.",
  },
  "mahadasha/shani": {
    title: "Shani (Saturn) Mahadasha: 19-Year Cosmic Discipline & Karma Resolution",
    description:
      "Shani's 19-year Mahadasha: its karmic lessons, how it shapes career, health and relationships, and the remedies for an afflicted Saturn.",
    ogTitle: "Shani (Saturn) Mahadasha: 19-Year Cosmic Discipline & Karma Resolution",
    ogDescription:
      "Understand Shani's 19-year Mahadasha cycle - its karmic lessons, remedies during affliction, and how Saturn's transit impacts career, health, and relationships per Vedic Jyotish.",
  },
  "mahadasha/venus": {
    title: "Shukra (Venus) Mahadasha: 20-Year Planetary Cycle & Remedies",
    description:
      "Discover Shukra Mahadasha's 20-year influence on wealth, relationships, and creativity.",
    ogTitle: "Shukra (Venus) Mahadasha: 20-Year Planetary Cycle & Remedies",
    ogDescription:
      "Discover Shukra Mahadasha's 20-year influence on wealth, relationships, and creativity. Learn Vedic remedies from Brihat Parashara Hora Shastra for harmonious outcomes.",
  },
};
